import getProtocolFromPriority from './getProtocolFromPriority';

export default (localCandidate) => {
  if (localCandidate) {
    const { relayProtocol, priority } = localCandidate;

    if (relayProtocol) {
      const RELAY_PROTOCOL = relayProtocol.toUpperCase();

      return `TURN/${RELAY_PROTOCOL}`;
    }
    return getProtocolFromPriority(priority);
  }

  return '';
};
